// extracted by mini-css-extract-plugin
export default {"slideImgDiv":"Slider_slideImgDiv__V2-zE"};